import { CHCValueProp } from "./value-prop.component.js";
customElements.define("chc-value-prop", CHCValueProp);
export {
  CHCValueProp
};
//# sourceMappingURL=value-prop.js.map
